import PluginDecorator from './PluginDecorator';
import {PlayerComponentHookType} from "../../components/wrappers/PlayerComponentWrapper";
import Dom from "../../utils/custom/Dom";
import {PlaylistEventType} from "./PlaylistPluginDecorator";
import mergeOptions from "../../utils/wrappers/merge-options";
import UrlWrapper from "../../utils/wrappers/Url";

// load plugin
require('../../../customized_vendor/videojs-vtt-thumbnails/videojs.thumbnails.js');
require('../../../customized_vendor/videojs-vtt-thumbnails/videojs.thumbnails.css');

// load promise-based ajax framework
import axios from 'axios';

export default class VttThumbnailsPluginDecorator extends PluginDecorator{

    static readonly PLUGIN_NAME = 'thumbnails';

    static readonly CUSTOM_TRACK_KIND_NAME = 'thumbnails';
    static readonly  THUMBNAIL_HOLDER_CLASS_NAME = 'vjs-thumbnail-holder';

    static bootingStaticApi() {
        super.bootingStaticApi();
        this.hookManagerInstance.add<PlayerComponentHookType>('BEFORE_SETUP', (videoEl: Element, options: any) => {
            return this.processOptions(options);
        });
    }

    static processOptions(options: any) {

        // // get option section for plugin (create new object, when don't exists)
        // let pluginOptions = options.plugins.videoJsResolutionSwitcher =
        //     options.plugins.videoJsResolutionSwitcher || {};

        // check qualities
        options.playlist.forEach(function (playlistItem: any) {

            // prepare "kind" property of "thumbnails" track
            playlistItem.textTracks && playlistItem.textTracks.forEach(function(track:HTMLTrackElement){
                if(track.kind == VttThumbnailsPluginDecorator.CUSTOM_TRACK_KIND_NAME){
                    // backup original "kind" name
                    (<any>track).customizedKind = track.kind;
                    // rename "kind" to plugin compatible kind type
                    track.kind = 'metadata';
                }
            })

        });

        return options;
    }

    protected oldThumbnailTrackOption:any = null;

    protected activeThumbnailPluginInstance:any = null;

    protected progressControl:VideoJSComponent;

    public bootingExecution(){

        // reinitialize, vtt thumbnail plugin, when playlist object is updated OR current playlist item has changed
        this.eventManager.addListener<PlaylistEventType>('PLAYLIST_UPDATED', (e:any, item:any) => this.updateThumbnailTrack(item));
        this.eventManager.addListener<PlaylistEventType>('PLAYLIST_ITEM_CHANGE', (e:any) => this.updateThumbnailTrack());

        // load references
        this.progressControl = this.skyClickPlayer.getChild('ControlBar').getChild('ProgressControl');

        // run item change lister at startup
        this.updateThumbnailTrack();
    }

    protected updateThumbnailTrack(currentItem:any = null){
        /*  Fix Safari bug(confirmed on version 11):
           Unstable thumbnail plugin (sometimes no thumbnail, sometimes only thumbnail wrapper with out thumbnail image, ....)

            Solution:
           Use setTimeout of 0 ms, because we must wait to run this function until all other running js process are finished (see https://stackoverflow.com/a/779785).
           The reason, why we have to wait is, because the vtt thumbnail plugin run this code line "thumbTrack.mode = 'hidden'" (src/customized_vendor/videojs-vtt-thumbnails/videojs.thumbnails.js:90)
           to trigger a behavior of the "mode" property setter (node_modules/video.js/es5/tracks/text-track.js:274) on the textTrack object.

           The update of the "mode" property cause, that the textTrack object trigger the "change" event on himself.
           And only when this event("change") is triggered on the vtt thumbnail textTrack instance, the thumbnail data will be loaded
           (We don't understand the behavior with the "change" event entirely, but this is the state of our discovery).

           The setTimeout of 0 ms is need, because in Safari no textTrack wasn't available, when the plugin will access it to change the "mode" property of it.
           So we implemented the setTimeout method to wait until all other rurning js process are finished.
           Perhaps in background running some other async events they update the textTracks in player instance.
           Info: The textTracks will be updated by the playlist plugin before the event "PLAYLIST_ITEM_CHANGE" is triggered(node_modules/videojs-playlist/dist/videojs-playlist.js:134), which trigger this method)
         */
        setTimeout(() => {
            let currentPlaylistItem = currentItem || this.playlistDecorator.getCurrentItem();

            if(currentPlaylistItem){

                let currentThumbnailTrackOption = this.extractThumbnailTrackOption(currentPlaylistItem.textTracks);

                // disable thumbnail
                if(!currentThumbnailTrackOption){
                    this.disposePlugin();
                    // track removing not needed, because all tracks are removed after playlist item change
                }else if(this.oldThumbnailTrackOption !== currentThumbnailTrackOption){
                    this.disposePlugin();

                    // Only init thumbnail plugin, when vtt thumbnail track file exists
                    this.existsDefinedThumbnailFile(currentThumbnailTrackOption.src)
                        .then(() => {

                            // extract base path automatically
                            let basePathMatch = /(.*)\//.exec(currentThumbnailTrackOption.src);
                            let basePath = basePathMatch[0] || '';

                            // overwrite basePath by main option, when defined
                            let options = mergeOptions({basePath}, this.skyClickPlayer.getOptions().plugins.thumbnails);

                            // update plugin
                            this.activeThumbnailPluginInstance = this.skyClickPlayer.thumbnails(options);

                        })
                        .catch(function(){
                            console.warn('thumbnail file don\'t exists: ', currentThumbnailTrackOption.src);
                        });
                }

                // update reference to oldThumbnailTrack
                this.oldThumbnailTrackOption = currentThumbnailTrackOption;

            }
        },0);
    }

    protected extractThumbnailTrackOption(trackList:any[]){
        const extractedTrack = trackList && trackList.filter((track) =>  track.customizedKind == VttThumbnailsPluginDecorator.CUSTOM_TRACK_KIND_NAME);
        return extractedTrack && extractedTrack.length == 1 ? extractedTrack[0] : null;
    }

    /**
     * Dispose vtt thumbnail plugin
     */
    protected disposePlugin(){
        // Remove the thumbnail vtt view
        let thumbnailHolder = Dom.$('.' + VttThumbnailsPluginDecorator.THUMBNAIL_HOLDER_CLASS_NAME, this.progressControl.el());
        thumbnailHolder && Dom.removeEl(thumbnailHolder);

        // Dispose plugin, remove all event listeners
        this.activeThumbnailPluginInstance && this.activeThumbnailPluginInstance.dispose();
    }

    /**
     * Return promise, that check, exists the the given vtt thumbnail track file
     * @param relativeThumbnailFilePath
     * @returns {Promise<Response>}
     */
    protected existsDefinedThumbnailFile(relativeThumbnailFilePath:string){
        let absolutePath = relativeThumbnailFilePath && UrlWrapper.getAbsoluteURL(relativeThumbnailFilePath);
        return axios.get(absolutePath);
    }

}


// WEBPACK FOOTER //
// ./src/app/plugins/decorators/VttThumbnailsPluginDecorator.ts